import React, { useContext } from 'react';

export const StepContext = React.createContext({ days: [] });

export function useStepContext() {
  return useContext(StepContext);
}
